"use client";

import React, { useEffect } from "react";
import sal from "sal.js";

/**
 * Componente RefundPolicy que muestra la política de devoluciones.
 * Se encarga de inicializar las animaciones de sal.js al montar el componente.
 *
 * @returns {JSX.Element} - Renderizado de la sección de política de devoluciones.
 */
const RefundPolicy = () => {
  useEffect(() => {
    sal();
  }, []);

  return (
    <div className="rainbow-pricing-area rainbow-section-gap">
      <div className="container-fluid">
        <div className="wrapper rainbow-contact-area">
          <div className="container pl--0 pr--0">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="section-title text-center"
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-delay="150"
                >
                  <h2 className="subtitle text-2xl font-bold">
                    <span className="theme-gradient">
                      Política de devoluciones
                    </span>
                  </h2>
                </div>
              </div>
            </div>

            <div className="row mt--40 row--15">
              <div className="col-lg-12">
                <p>
                  En <strong>TutorIA+</strong>, queremos que tengas claridad y
                  confianza al suscribirte. Por ello, ofrecemos una política de
                  reembolso simple y transparente.
                </p>

                <h4>1. Ventana de reembolso</h4>
                <p>
                  Puedes solicitar un <strong>reembolso completo</strong> dentro
                  de los <strong>14 días calendario</strong> posteriores a tu
                  compra (contados desde el día siguiente a la compra).
                </p>

                <h4>2. Cómo solicitar un reembolso</h4>
                <p>
                  Para solicitarlo, escríbenos a{" "}
                  <a href="mailto:contacto@tutoriaplus.com">
                    contacto@tutoriaplus.com
                  </a>{" "}
                  incluyendo:
                </p>
                <ul className="content-list">
                  <li>Nombre del titular de la compra.</li>
                  <li>Correo electrónico usado al comprar.</li>
                  <li>Fecha de compra y/o comprobante de pago.</li>
                  <li>Motivo de la solicitud (opcional).</li>
                </ul>

                <h4>3. Procesamiento del reembolso</h4>
                <ul className="content-list">
                  <li>
                    Una vez recibida tu solicitud, la procesaremos{" "}
                    <strong>sin demora indebida</strong> y, como máximo, dentro
                    de los <strong>14 días calendario</strong> desde que nos
                    informas tu decisión de solicitar el reembolso.
                  </li>
                  <li>
                    El reembolso se realizará usando el{" "}
                    <strong>mismo método de pago</strong> utilizado en la compra
                    original.
                  </li>
                  <li>
                    El tiempo en verse reflejado puede depender de tu banco o
                    proveedor de pago.
                  </li>
                </ul>

                <h4>4. Suscripciones y renovaciones</h4>
                <p>
                  Si tu compra corresponde a una <strong>suscripción</strong>,
                  puedes solicitar el reembolso dentro de los{" "}
                  <strong>14 días calendario</strong> posteriores a la{" "}
                  <strong>suscripción inicial</strong>. Este derecho no aplica a
                  cada renovación automática posterior.
                </p>

                <h4>5. Cancelación de suscripción</h4>
                <p>
                  Puedes cancelar tu suscripción en cualquier momento. Al
                  cancelar, tu acceso se mantendrá activo hasta el final del
                  período vigente.
                </p>

                <h4>6. Cambios a esta política</h4>
                <p>
                  Podemos actualizar esta política para mantenerla clara y
                  vigente. Cualquier cambio será publicado en esta página.
                </p>

                <p>
                  <strong>Fecha de última actualización:</strong> 26 de enero de
                  2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
